<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <div class="tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center">
                Form title
            </div>
            <fieldset class="tw-px-3 tw-pb-3 lg:tw-px-12 lg:tw-pb-12">
                <validation-provider class="tw-w-full tw-w-block" name="fullName" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-name" :class="classes">
                        <input type="text"
                            id="input-fullName"
                            placeholder=" "
                            v-model="fullName"
                        >
                        <label>
                            Nome e Apelido
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:fr" v-slot="{ classes }">
                    <div class="input-group input-group-phone" :class="classes">
                        <input type="tel"
                            id="input-phone"
                            placeholder=" "
                            v-model="phone"
                            v-mask="'999999999'"
                        >
                        <label>
                            Telefone
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }">
                    <div class="input-group input-group-email" :class="classes">
                        <input type="email"
                            id="input-email"
                            placeholder=" "
                            v-model.lazy="email"
                        >
                        <label>
                            Email {{ errors [0]}}
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                <span class="checkmark"></span>
                                <span class="tw-text-black">Autorizo a {{ company }} a utilizar os meus dados para ser contactado segundo a sua <a href="#" @click.prevent="$store.state.modal.terms = true"><u>política de privacidade</u></a>.</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>
                <div class="tw-text-center tw-mt-4">
                    <button
                        type="submit"
                        class="btn-cta"
                        id="submit"
                        :disabled="formLoading"
                    >
                        ENVIAR
                    </button>
                </div>
            </fieldset>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';

export default {
    name: 'FormComponent',
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',

            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        formSubmit() {
            this.formLoading = true;

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,

                fullName: this.fullName,
                phone: this.phone,
                email: this.email,
            };

            const config = {
                headers: {
                    Authorization : 'Bearer ' + this.$store.state.token,
                    Language : this.$i18n.locale,
                }
            }

            axios.post(action, data, config)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'Mensagem de Erro de Email duplicado ( . Y . )';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
</style>
